import {
  Button,
  CloseButton,
  Grid,
  Heading,
  IconAddLine,
  List,
  Modal,
} from "@instructure/ui";
import { useTranslation } from "react-i18next";
import React, { useContext, useState } from "react";
import { CycleContext } from "../CyclesAndGoals";
import { CycleTypeEditModal } from "./CycleTypeEditModal";
import CycleTypeEntry from "./CycleTypeEntry";

export const CycleTypePanel = ({ open, setOpen }) => {
  const { t } = useTranslation();
  const { cycleTypes } = useContext(CycleContext);
  const [openAddType, setOpenAddType] = useState(false);

  return (
    <>
      <Modal
        as="form"
        open={open}
        size="medium"
        label={t("cyclesAndGoals.cycleType.configure")}
      >
        <Modal.Header>
          <Grid hAlign="space-between">
            <Grid.Row>
              <Grid.Col>
                <Heading level="h2" as="h1">
                  {t("cyclesAndGoals.cycleType.configure")}
                </Heading>
              </Grid.Col>
              <Grid.Col width="auto">
                <CloseButton
                  size="small"
                  screenReaderLabel={t("global.close")}
                  onClick={() => setOpen(false)}
                />
              </Grid.Col>
            </Grid.Row>
          </Grid>
        </Modal.Header>
        <Modal.Body>
          <Grid hAlign="end" vAlign="middle">
            <Grid.Row>
              <Grid.Col width="auto">
                <Button
                  id="add-cycle-type-button"
                  color="primary"
                  onClick={() => setOpenAddType(true)}
                  renderIcon={IconAddLine}
                >
                  {t("cyclesAndGoals.cycleType.addCycleTypeButton")}
                </Button>
              </Grid.Col>
            </Grid.Row>
          </Grid>
          <div style={{ marginTop: 15 }}>
            <List isUnstyled>
              {cycleTypes.map((type) => (
                <List.Item key={type.id}>
                  <CycleTypeEntry cycleType={type} />
                </List.Item>
              ))}
            </List>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setOpen(false)} margin="0 x-small 0 0">
            {t("global.close")}
          </Button>
        </Modal.Footer>
      </Modal>
      <CycleTypeEditModal open={openAddType} setOpen={setOpenAddType} />
    </>
  );
};
